// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KOBD","disabled":"styles_disabled__3zYD3"};